/* Orphée — relocate complementary-products section into product info column on desktop.
   On viewports >= 990px, moves the section wrapper containing
   <product-recommendations id="complementaryProducts"> into
   .product__info-container (right column, after the accordions).
   On mobile it stays in its original position below the product.

   The theme's own IntersectionObserver (inside complementary-products
   section) fetches recommendation HTML lazily; DOM moves don't break the
   observer because it queries the element by class, so the reference is
   preserved after relocation. MutationObserver on the target catches the
   async fetch completion and re-applies compact styling if needed. */
(function() {
  'use strict';

  var DESKTOP_MIN = 990;
  var RELOCATED_CLASS = 'orphee-complementary-relocated';

  var originalParent = null;
  var originalNextSibling = null;

  function findSectionElement() {
    var rec = document.querySelector('#complementaryProducts');
    if (!rec) return null;
    // Move the outermost <section> wrapper so we take the full section
    // (with heading, grid, arrows) as one unit.
    return rec.closest('section') || rec.parentElement;
  }

  function relocate() {
    var section = findSectionElement();
    if (!section) return;
    var infoContainer = document.querySelector('.product__info-container');
    if (!infoContainer) return;

    var isDesktop = window.innerWidth >= DESKTOP_MIN;

    if (isDesktop) {
      // Save original position exactly once so we can restore on resize.
      if (!originalParent) {
        originalParent = section.parentNode;
        originalNextSibling = section.nextSibling;
      }
      if (section.parentNode !== infoContainer) {
        infoContainer.appendChild(section);
      }
      if (!section.classList.contains(RELOCATED_CLASS)) {
        section.classList.add(RELOCATED_CLASS);
      }
    } else {
      // Restore to original position on mobile so it appears below product.
      if (originalParent && section.parentNode !== originalParent) {
        if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
          originalParent.insertBefore(section, originalNextSibling);
        } else {
          originalParent.appendChild(section);
        }
      }
      section.classList.remove(RELOCATED_CLASS);
    }
  }

  function init() {
    relocate();

    // The theme lazy-fetches recommendation HTML via IntersectionObserver
    // and swaps innerHTML on <product-recommendations>. Watch for that
    // swap and re-run relocate() so class stays applied on any new noden.
    var rec = document.querySelector('#complementaryProducts');
    if (rec) {
      var mo = new MutationObserver(function() {
        // Re-ensure the relocated class + position after content swap.
        var section = findSectionElement();
        if (section && window.innerWidth >= DESKTOP_MIN &&
            !section.classList.contains(RELOCATED_CLASS)) {
          section.classList.add(RELOCATED_CLASS);
        }
      });
      mo.observe(rec, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Debounced resize handler
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(relocate, 150);
  });
})();
